module.exports = __webpack_public_path__ + "img/dressshow.73d7cbde.png";